import React, { useState, useEffect } from 'react';
import { getTranslations } from '../../../../../../services/languageUtils';
import { NumericFormat } from 'react-number-format';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InputMask from 'react-input-mask';

// PIX por chave pede só a chave. Desde 26/10/2026 o DICT devolve o CPF do recebedor
// mascarado (determinação do Banco Central), e quem paga não precisa informar nome nem
// documento: o recebedor é resolvido pela chave no backend.
function TransferTypePixMutual({
  currentPayment,
  pixKeyType,
  keySearchPix,
  handleChangeKeyPix,
  handleKeyTypeChange,
  currentBalance,
  updateValueTransfer,
  sendPayment,
  amount,
  loadingTranfer,
}) {
  const [translations, setTranslations] = useState({});
  let inputMask = "";

  switch (pixKeyType) {
    case "CPF":
      inputMask = "999.999.999-99";
      break;
    case "CNPJ":
      inputMask = "99.999.999/9999-99";
      break;
    case "Telefone":
      inputMask = "(99) 99999-9999";
      break;
    default:
      inputMask = "";
  }

  useEffect(() => {
    const loadTranslations = async () => {
      const trans = await getTranslations(localStorage.getItem('language') || 'pt');
      setTranslations(trans);
    };
    loadTranslations();
  }, []);

  // Nome e documento vão sempre vazios: um valor que sobrou de um pagamento por QR Code
  // não pode seguir junto de um pagamento por chave.
  const propagateChanges = (newAmount, _newDoc, _newName, newPixType, newKey) => {
    updateValueTransfer(
      newAmount !== undefined && newAmount !== null
        ? newAmount
        : currentPayment?.amount ?? amount ?? 0,
      '',
      '',
      newPixType !== undefined && newPixType !== null
        ? newPixType
        : pixKeyType ?? currentPayment?.creditParty?.dictType ?? '',

      newKey !== undefined && newKey !== null
        ? newKey
        : keySearchPix ?? currentPayment?.creditParty?.key ?? ''
    );
  };

  return (
    <div>
      <span className="desktop">
        <div className="mainContent">
          <p className="pTitle">{translations.who_to_transfer}</p>
          <p className="pLabel"><br />{translations.search_by_contact_or_pix_key}</p>

          <select
            className="select"
            value={pixKeyType}
            onChange={(e) => {
              handleKeyTypeChange(e);
              propagateChanges(null, null, null, e.target.value, null);
            }}
          >
            <option value="CPF">CPF</option>
            <option value="CNPJ">CNPJ</option>
            <option value="Telefone">Telefone</option>
            <option value="Email">Email</option>
            <option value="Chave Aleatória">Chave Aleatória</option>
          </select>

          <InputMask
            type="text"
            placeholder={translations.pix_key}
            className="input"
            id="keySearchPix"
            mask={inputMask}
            value={keySearchPix}
            onChange={(e) => {
              handleChangeKeyPix(e);
              propagateChanges(null, null, null, null, e.target.value);
            }}
          />
        </div>

        <div className="mainContent" style={{ borderRadius: "0px 8px 8px 0px" }}>
          <p className="pTitle spaceBetween">
            <span>{translations.amount}</span>
            <span style={{ fontWeight: "700" }}>
              {translations.currency_prefix}{' '}
              {currentBalance.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </span>
          </p>

          <div style={{ display: "flex", marginTop: "10px" }}>
            <div>
              <span className="labelGray">{translations.how_much_transfer}</span>
              <NumericFormat
                className="input"
                value={currentPayment.amount}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                prefix={translations.currency_prefix}
                onValueChange={(values) => {
                  const { value } = values;
                  propagateChanges(value, null, null, null, null);
                }}
              />
            </div>
          </div>
          <br />

          <div
            className={`buttonSend ${loadingTranfer ? 'disabled' : ''}`}
            onClick={!loadingTranfer ? () => sendPayment(2) : null}
          >
            {loadingTranfer ? <div className="loader"></div> : translations.complete_transfer}
          </div>
        </div>
      </span>

      <span className="mobile">
        <div>
          <div className="mainContent">
            <p className="pTitle">{translations.who_to_transfer}</p>
            <p className="pLabel"><br />{translations.search_by_contact_or_pix_key}</p>

            <select
              className="select"
              value={pixKeyType}
              onChange={(e) => {
                handleKeyTypeChange(e);
                propagateChanges(null, null, null, e.target.value, null);
              }}
            >
              <option value="CPF">CPF</option>
              <option value="CNPJ">CNPJ</option>
              <option value="Telefone">Telefone</option>
              <option value="Email">Email</option>
              <option value="Chave Aleatória">Chave Aleatória</option>
            </select>

            <InputMask
              type="text"
              placeholder={translations.pix_key}
              className="input"
              id="keySearchPix"
              mask={inputMask}
              value={keySearchPix}
              onChange={(e) => propagateChanges(null, null, null, null, e.target.value)}
            />

            <span className="labelGray">{translations.how_much_transfer}</span>
            <NumericFormat
              className="input"
              value={currentPayment.amount}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale
              prefix={translations.currency_prefix}
              onValueChange={(values) => {
                const { value } = values;
                propagateChanges(value, null, null, null, null);
              }}
            />

            <div
              className={`buttonSend ${loadingTranfer ? 'disabled' : ''}`}
              onClick={!loadingTranfer ? () => sendPayment(2) : null}
            >
              {loadingTranfer ? <div className="loader"></div> : translations.complete_transfer}
            </div>
          </div>
        </div>
      </span>

      <ToastContainer />
    </div>
  );
}

export default TransferTypePixMutual;
